export const SET_DATA = (state, { id, data }) => {
  state[id] = data;
};
export const setModalLogin = (state, isShow) => {
  state.showLogin = isShow;
};
export const setRedirect = (state, isRedirect) => {
  state.isRedirect = isRedirect;
};
export const setIsLogin = (state, isShow) => {
  state.isLogin = isShow;
};
export const setUser = (state, item) => {
  state.user = item;
};
export const setLevel = (state, level) => {
  state.level = level;
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js